/* C4 -- bulk-rate readout for Print Options (online) product pages.
 *
 * Cathy, 26 Oct 2026: the new calculator pages were "missing the per unit pricing and the
 * strikethroughs" that the Apippa pages show (c4-you-save.js). This is the same readout, fed by
 * Print Options instead of a port of Apippa's engine:
 *
 *   - Add to cart button: "~~58c per card~~ 14.4c per card" -- the rate at the SMALLEST quantity
 *     the calculator offers (every other option as chosen), struck through, beside the live rate.
 *     The live each-price itself is written by c4-main-product.liquid's sync script.
 *   - Price box: the same row ([data-c4-price-rate]) and "as low as 4.4c per card"
 *     ([data-c4-price-low]) -- the best rate at the LARGEST quantity, other options as chosen.
 *   - Mobile sticky bar ([data-c4-sticky-rate]) mirrors the row when it exists.
 *
 * HOW THE OTHER PRICES ARE FOUND. Print Options prices on the page, synchronously: setSelections()
 * followed by state.price gives the exact figure the configurator itself would show. We set the
 * quantity to the smallest / largest preset, read the price, and put the customer's quantity back
 * in the same tick (nothing repaints in between). Writes are tagged source 'c4-probe' and our own
 * change listener ignores them. If anything looks wrong (no price, the restore did not land back on
 * the same total) nothing is shown -- a wrong rate is worse than none.
 *
 * Nothing here touches the cart: the price charged is always recomputed by Print Options' servers.
 */
(function () {
  if (window.__c4PoSave) return;
  window.__c4PoSave = true;

  var SRC = 'c4-probe';

  function po() {
    var el = document.querySelector('print-configurator');
    return el && el.state && el.schema ? el : null;
  }
  function qtyField(el) {
    var secs = (el.schema && el.schema.sections) || [];
    for (var i = 0; i < secs.length; i++) {
      var fs = secs[i].fields || [];
      for (var j = 0; j < fs.length; j++) {
        if (fs[j].type === 'quantity' && !isHiddenField(el, fs[j].id)) return fs[j];
      }
    }
    return null;
  }
  /* A product can carry more than one quantity field, switched by logic (e.g. Velvet). The one in
     use is the one whose id is in the current selections. */
  function isHiddenField(el, id) {
    var sel = (el.state && el.state.selections) || {};
    return !Object.prototype.hasOwnProperty.call(sel, id);
  }
  function presetRange(f) {
    var ps = (f.presets || []).map(Number).filter(function (n) { return isFinite(n) && n > 0; });
    var lo = ps.length ? Math.min.apply(null, ps) : Number(f.min);
    var hi = ps.length ? Math.max.apply(null, ps) : Number(f.max);
    if (!(lo > 0)) lo = 1;
    if (!(hi > 0)) hi = lo;
    return { lo: lo, hi: hi };
  }
  function priceAt(el, fid, q) {
    var o = {};
    o[fid] = q;
    el.setSelections(o, { source: SRC });
    var p = el.state && el.state.price;
    return p && !p.unavailable ? Number(p.total) : NaN;
  }

  function unitWord() {
    var b = document.querySelector('[data-c4-cta]');
    var n = b && b.getAttribute('data-c4-unit-noun');
    return n ? ('per ' + n) : 'each';
  }
  function each(n) {
    return n < 1 ? (Math.round(n * 1000) / 10).toString().replace(/\.0$/, '') + 'c' : '$' + n.toFixed(2);
  }

  function setStruck(el, lead, struck) {
    var key = lead + '|' + struck;
    if (el.getAttribute('data-c4-txt') !== key) {
      el.textContent = '';
      var s = document.createElement('s');
      s.textContent = struck;
      el.appendChild(s);
      if (lead) el.appendChild(document.createTextNode(' ' + lead));
      el.setAttribute('data-c4-txt', key);
    }
    if (el.hidden) el.hidden = false;
  }
  var MIRRORS = '[data-c4-price-rate], [data-c4-sticky-rate]';
  function mirror(struck, unit) {
    var key = struck + '|' + unit;
    [].slice.call(document.querySelectorAll(MIRRORS)).forEach(function (el) {
      if (el.getAttribute('data-c4-txt') !== key) {
        el.textContent = '';
        var em = document.createElement('em');
        setStruck(em, '', struck);
        el.appendChild(em);
        var i = document.createElement('i');
        i.textContent = unit;
        el.appendChild(i);
        el.setAttribute('data-c4-txt', key);
      }
      if (el.hidden) el.hidden = false;
    });
  }
  function clearRate() {
    [].slice.call(document.querySelectorAll(MIRRORS)).forEach(function (el) { if (!el.hidden) el.hidden = true; });
    var btn = document.querySelector('[data-c4-cta]');
    if (!btn) return;
    var save = btn.querySelector('[data-c4-cta-save]');
    if (save && !save.hidden) save.hidden = true;
    if (btn.hasAttribute('data-c4-saving')) btn.removeAttribute('data-c4-saving');
  }
  function clearLow() {
    var el = document.querySelector('[data-c4-price-low]');
    if (el && !el.hidden) el.hidden = true;
  }

  function render() {
    var el = po();
    if (!el) return;
    var f = qtyField(el);
    var live = el.state.price && !el.state.price.unavailable ? Number(el.state.price.total) : NaN;
    var q = Number(el.state.quantity);
    if (!f || !(live > 0) || !(q > 0)) { clearRate(); clearLow(); return; }

    var r = presetRange(f);
    var lowP = NaN, highP = NaN;
    try {
      lowP = r.lo !== q ? priceAt(el, f.id, r.lo) : live;
      highP = r.hi !== q ? priceAt(el, f.id, r.hi) : live;
    } finally {
      var back = priceAt(el, f.id, q);          /* always put the customer's quantity back */
      if (!(Math.abs(back - live) < 0.005)) { clearRate(); clearLow(); return; }
    }

    var eachNow = live / q;
    var word = unitWord();

    /* Struck smallest-quantity rate beside the live one. */
    var eachBase = lowP / r.lo;
    var btn = document.querySelector('[data-c4-cta]');
    if (q > r.lo && isFinite(eachBase) && eachBase > eachNow * 1.01 && btn) {
      var save = btn.querySelector('[data-c4-cta-save]');
      if (save) setStruck(save, '', each(eachBase) + ' ' + word);
      var unitEl = btn.querySelector('[data-c4-cta-unit]');
      mirror(each(eachBase) + ' ' + word, unitEl && !unitEl.hidden ? unitEl.textContent : each(eachNow) + ' ' + word);
      if (!btn.hasAttribute('data-c4-saving')) btn.setAttribute('data-c4-saving', '');
    } else {
      clearRate();
    }

    /* "as low as" -- the largest-quantity rate, when it is at least 1 % better than now. */
    var lowEl = document.querySelector('[data-c4-price-low]');
    var best = highP / r.hi;
    if (lowEl) {
      if (isFinite(best) && eachNow > best * 1.01) {
        var txt = 'as low as ' + each(best) + ' ' + word;
        if (lowEl.textContent !== txt) lowEl.textContent = txt;
        if (lowEl.hidden) lowEl.hidden = false;
      } else if (!lowEl.hidden) {
        lowEl.hidden = true;
      }
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; try { render(); } catch (e) { clearRate(); clearLow(); } }, 250);
  }

  var wired = false;
  function wire() {
    var el = po();
    if (!el || wired) return !!el;
    wired = true;
    el.addEventListener('change', function (e) {
      var d = e && e.detail;
      if (d && d.source === SRC) return;        /* our own probes */
      schedule();
    });
    schedule();
    return true;
  }
  /* Print Options mounts when it finishes loading; wait for it (up to ~30s). */
  var tries = 0;
  (function boot() {
    if (wire()) return;
    if (tries++ > 120) return;
    setTimeout(boot, 250);
  })();
  /* The each-price in the button is written by the page's own sync script a moment after a change;
     run once more after it so the mirrored row picks it up. */
  document.addEventListener('c4:price', schedule);
})();
